import { makeStyles } from '@mui/styles';
import { Theme, styled } from '@quillbot/design-system';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  loadingBarColor: {
    color: theme.specialColors.LOADING_BAR,
  },
}));

const StyledLoadingText = styled('span')`
  position: absolute;
  left: 0;

  right: 0;
  margin: auto;
`;

function Loading(props: { isLoading: boolean }) {
  const classes = useStyles();
  return props.isLoading ? (
    <div id="overlay">
      <div className={`${classes.loadingBarColor} spinner`} />
      <br />
      <StyledLoadingText className={classes.loadingBarColor}>Loading...</StyledLoadingText>
    </div>
  ) : (
    <></>
  );
}

export default Loading;
